import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";
import { InsightItem } from "@/types/insights";
import { ComponentCard } from "./InsightsComponentCard";
import { sentimentBadgeClassNames } from "./insights-component-utils";

export const InsightsListCard = ({
  insights,
}: {
  insights: InsightItem[];
}) => {
  if (insights.length === 0) return null;

  return (
    <ComponentCard>
      <div className="space-y-3">
        {insights.map((item, index) => (
          <div
            key={`insight-${index}-${item.title}`}
            className="rounded-lg border border-border/70 bg-background px-4 py-3"
          >
            <div className="flex items-start justify-between gap-3">
              <div className="space-y-1">
                <p className="text-sm font-medium leading-6 text-foreground">{item.title}</p>
                <p className="text-sm leading-6 text-muted-foreground">{item.description}</p>
              </div>
              <Badge
                variant="outline"
                className={cn("capitalize", sentimentBadgeClassNames[item.sentiment])}
              >
                {item.sentiment}
              </Badge>
            </div>
            <div className="mt-3 flex flex-wrap gap-2 text-xs text-muted-foreground">
              {item.frequency !== null && item.frequency !== undefined ? (
                <span>{item.frequency} occurrences</span>
              ) : null}
            </div>
          </div>
        ))}
      </div>
    </ComponentCard>
  );
};
